"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InteractableContent = exports.Interactable = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Interactable.css");
var _cdsCommon = require("@cbhq/cds-common");
var _ElevationProvider = require("@cbhq/cds-common/context/ElevationProvider");
var _useInteractableBorderRadius = require("@cbhq/cds-common/hooks/useInteractableBorderRadius");
var _paletteConfigToInteractableTokens = require("@cbhq/cds-common/palette/paletteConfigToInteractableTokens");
var _useElevationStyles = require("../hooks/useElevationStyles");
var _usePalette = require("../hooks/usePalette");
var borderColors = _interopRequireWildcard(require("../styles/borderColor"));
var borderWidths = _interopRequireWildcard(require("../styles/borderWidth"));
var _disabledState = require("../styles/disabledState");
var _focus = require("../styles/focus");
var _linaria = require("../utils/linaria");
var _interactableCSSProperties = require("./interactableCSSProperties");
const _excluded = ["as", "background", "block", "borderColor", "borderRadius", "borderWidth", "children", "className", "disabled", "elevation", "loading", "pressed", "style", "testID", "transparentWhileInactive", "width", "height", "accessibilityLabel", "accessibilityLabelledBy", "accessibilityHint"],
  _excluded2 = ["children"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const interactable = "cds-interactable-i9xooc6";
const fullWidth = "cds-fullWidth-fnzgr0o";
const InteractableContent = /*#__PURE__*/(0, _react.forwardRef)(function InteractableContent(_ref, ref) {
  let Container = _ref.as,
    background = _ref.background,
    block = _ref.block,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? 'transparent' : _ref$borderColor,
    borderRadius = _ref.borderRadius,
    borderWidth = _ref.borderWidth,
    children = _ref.children,
    customClassName = _ref.className,
    disabled = _ref.disabled,
    elevation = _ref.elevation,
    loading = _ref.loading,
    pressed = _ref.pressed,
    customStyle = _ref.style,
    testID = _ref.testID,
    transparentWhileInactive = _ref.transparentWhileInactive,
    width = _ref.width,
    height = _ref.height,
    accessibilityLabel = _ref.accessibilityLabel,
    accessibilityLabelledBy = _ref.accessibilityLabelledBy,
    accessibilityHint = _ref.accessibilityHint,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const palette = (0, _usePalette.usePalette)();
  const paletteConfig = (0, _cdsCommon.usePaletteConfig)();
  const elevationStyles = (0, _useElevationStyles.useElevationStyles)(elevation);
  const spectrum = (0, _cdsCommon.useSpectrum)();
  const _paletteConfigToInter = (0, _paletteConfigToInteractableTokens.paletteConfigToInteractableTokens)({
      paletteConfig,
      spectrum,
      isWeb: true
    })[background],
    disabledToken = _paletteConfigToInter.disabled,
    pressedToken = _paletteConfigToInter.pressed,
    hoveredToken = _paletteConfigToInter.hovered;
  const borderRadiusValue = (0, _useInteractableBorderRadius.useInteractableBorderRadius)(borderRadius);

  /**
   * this variable should only be used when conditionally rendering the disabled DOM attribute
   */
  const shouldBeDisabled = loading || disabled;
  const className = (0, _linaria.cx)(interactable, disabled ? _disabledState.disabledState : _focus.focusRing, disabled && borderColor === 'transparent' ? _disabledState.disabledBorder : null, transparentWhileInactive ? borderColors.transparent : borderColors[borderColor], borderWidth && borderWidths[borderWidth], block && fullWidth, customClassName);
  const style = (0, _react.useMemo)(() => Object.assign({}, customStyle, {
    [_interactableCSSProperties.interactableBorderRadius]: `${borderRadiusValue}px`,
    [_interactableCSSProperties.interactableBackground]: transparentWhileInactive ? 'transparent' : palette[background],
    // Hover:
    [_interactableCSSProperties.interactableHoveredBackground]: hoveredToken ? hoveredToken.backgroundColor : undefined,
    [_interactableCSSProperties.interactableHoveredOpacity]: hoveredToken ? hoveredToken.contentOpacity : undefined,
    // Pressed:
    [_interactableCSSProperties.interactablePressedBackground]: pressedToken.backgroundColor,
    [_interactableCSSProperties.interactablePressedOpacity]: pressedToken.contentOpacity,
    // Disabled:
    [_interactableCSSProperties.interactableDisabledBackground]: disabledToken.backgroundColor,
    width,
    height
  }, elevationStyles), [background, borderRadiusValue, customStyle, disabledToken.backgroundColor, elevationStyles, height, hoveredToken, palette, pressedToken.backgroundColor, pressedToken.contentOpacity, transparentWhileInactive, width]);
  return /*#__PURE__*/(0, _react.createElement)(Container, Object.assign({
    'aria-pressed': pressed,
    'data-testid': testID,
    'aria-label': accessibilityLabel,
    'aria-labelledby': accessibilityLabelledBy,
    'aria-describedby': accessibilityHint
  }, props, {
    className,
    disabled: shouldBeDisabled,
    style,
    ref
  }), /*#__PURE__*/_react.default.createElement(_ElevationProvider.ElevationChildrenProvider, null, children));
});
exports.InteractableContent = InteractableContent;
const Interactable = /*#__PURE__*/(0, _react.forwardRef)(function Interactable(_ref2, ref) {
  let children = _ref2.children,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_ElevationProvider.ElevationProvider, {
    elevation: props === null || props === void 0 ? void 0 : props.elevation
  }, /*#__PURE__*/_react.default.createElement(InteractableContent, _extends({
    ref: ref
  }, props), children));
});
exports.Interactable = Interactable;